import * as React from 'react';
import { Row } from "reactstrap";
import { WrappedInput } from 'src/share/components/Input/Input';
import { getAgenciesFromCase } from "src/share/utils/getAgenciesFromCase";
import { IAuthState } from 'src/modules/Auth/store/types';
import { ICase } from 'src/share/types/case/case';

export interface IAgencyFormProps {
  caseInfo: ICase;
  auth: IAuthState
  setValue: (path: string, value: any) => Promise<any>
  form: (key: string, required?: boolean) => any;
  isEdit: boolean;
  isAdmin: boolean;
}

export default class AgencyForm extends React.Component<IAgencyFormProps> {
  public handleChangeAgency() {
    const { form: parentForm, setValue } = this.props
    const form = parentForm('agencyCode', true);
    return {
      ...form,
      onChange: event => {
        if (event && event.currentTarget && event.currentTarget.value === "") {
          setValue('center', null)
          setValue('location', null)
        }
        form.onChange(event)
      },
    }
  }
  public getAgencies() {
    const agencies = getAgenciesFromCase(this.props.caseInfo)
    return this.props.auth.agencies
      .sort((a, b) => a.country < b.country ? -1 : (a.country > b.country ? 1 : 0))
      .filter(agency => agencies.indexOf(agency.code) >= 0)
  }
  public isDisabled() {
    return !this.props.caseInfo.caseId || this.props.isEdit
  }
  public render() {
    if (this.props.isAdmin) {
      return (
        <>
          <Row>
            <h5>Agency</h5>
          </Row>
          <Row className="input">
            <WrappedInput type="select" {...this.handleChangeAgency()} disabled={this.isDisabled()}>
              <option value={''}>Select an Agency</option>
              {
                this.getAgencies().map((agencyData) =>
                  <option key={agencyData.code} value={agencyData.code}>{`${agencyData.country} - ${agencyData.name}`}</option>
                )
              }
            </WrappedInput>
          </Row>
        </>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/Alert/Create/components/AgencyForm.tsx